module.exports = __webpack_public_path__ + "static/icon-contracts-a6fbec2938f4a7ed62cba3a177f5651d.png";